import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {Injector} from "@angular/core";
import {AuthService} from "./auth.service";
import {Router} from "@angular/router";

export class JwtTokenInterceptor implements HttpInterceptor {

  private authService: AuthService;
  private router: Router;

  constructor(private injector: Injector) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authService = this.injector.get(AuthService);
    this.router = this.injector.get(Router);
    //console.log("JwtTokenInterceptor:intercept:request", request);
    return this.resolveRequest(request, next).do((response) => {
      //console.log("JwtTokenInterceptor#intercept:response", response);
    });
  }

  private resolveRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isUrlAuthenticated(request)) {
      return this.excecuteAuthRequest(request, next);
    } else {
      return this.excecuteRequest(next, request);
    }
  }

  private excecuteRequest(next: HttpHandler, request: HttpRequest<any>): Observable<HttpEvent<any>> {
    return next.handle(request);
  }

  private excecuteAuthRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log("JwtTokenInterceptor", this);
    return this.authService.isSessionValid().flatMap((isSessionValid) => {
      if (isSessionValid) {
        const authRequest = this.getAuthRequest(request);
        return next.handle(authRequest).do((event: HttpEvent<any>) => {
        }, this.handleUnauthorizedResponse);
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  private handleUnauthorizedResponse(err: any) {
    if (err instanceof HttpErrorResponse) {
      if (err.status === 401 || err.status === 403) {
        this.authService.signOut();
        this.router.navigate(['/login']);
      }
    }
  }

  private getAuthRequest(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authService.getToken()}`,
      },
      withCredentials: false
    });
  }

  private isUrlAuthenticated(request: HttpRequest<any>) {
    const isAuthenticatedUrl = request.withCredentials || false;
    //console.log("JwtTokenInterceptor:isUrlAuthenticated", isAuthenticatedUrl);
    return isAuthenticatedUrl;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/auth/jwt-token.interceptor.ts